import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

// Zapisuje raport do PDF (A4 poziomo, dowolna liczba stron).
// sekcje: elementy DOM w kolejności, w jakiej mają trafić do PDF.
// Sekcja, która mieści się na stronie, nie jest dzielona; dłuższą (np. tabelę) dzielimy
// w miejscach oznaczonych atrybutem data-pdf-break (koniec wiersza), żeby nie ciąć tekstu.
export async function zapiszRaportPdf(sekcje, nazwaPliku) {
  const pdf = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });
  const pageW = pdf.internal.pageSize.getWidth();
  const pageH = pdf.internal.pageSize.getHeight();
  const margines = 10;
  const stopka = 8;
  const odstep = 4;
  const szerokosc = pageW - 2 * margines;
  const dol = pageH - margines - stopka;
  const pelnaWysokosc = dol - margines;

  let y = margines;

  for (const el of sekcje) {
    if (!el) continue;
    const canvas = await html2canvas(el, {
      scale: 2,
      backgroundColor: "#ffffff",
      useCORS: true,
      logging: false,
      windowWidth: el.scrollWidth,
    });
    const pxNaMm = canvas.width / szerokosc;
    const rect = el.getBoundingClientRect();
    const skala = canvas.height / rect.height;
    const przerwy = [...el.querySelectorAll("[data-pdf-break]")]
      .map((b) => (b.getBoundingClientRect().bottom - rect.top) * skala)
      .filter((v) => v > 0 && v < canvas.height)
      .sort((a, b) => a - b);

    const wysokoscMm = canvas.height / pxNaMm;
    const miejsce = dol - y;
    // Przenieś całą sekcję na nową stronę, jeśli nie mieści się na bieżącej,
    // a zmieściłaby się na pustej (albo zostało za mało miejsca, żeby zacząć dzielenie).
    if (
      y > margines &&
      wysokoscMm > miejsce &&
      (wysokoscMm <= pelnaWysokosc || miejsce < 40)
    ) {
      pdf.addPage();
      y = margines;
    }

    let start = 0;
    while (start < canvas.height - 1) {
      const dostepnePx = (dol - y) * pxNaMm;
      let koniec = Math.min(canvas.height, start + dostepnePx);
      if (koniec < canvas.height) {
        const kandydaci = przerwy.filter((b) => b > start + 40 && b <= koniec);
        if (kandydaci.length) koniec = kandydaci[kandydaci.length - 1];
      }
      const wys = Math.max(1, Math.round(koniec - start));
      const kawalek = document.createElement("canvas");
      kawalek.width = canvas.width;
      kawalek.height = wys;
      kawalek
        .getContext("2d")
        .drawImage(canvas, 0, start, canvas.width, wys, 0, 0, canvas.width, wys);
      const wysMm = wys / pxNaMm;
      pdf.addImage(
        kawalek.toDataURL("image/jpeg", 0.92),
        "JPEG",
        margines,
        y,
        szerokosc,
        wysMm,
      );
      y += wysMm + odstep;
      start = koniec;
      if (start < canvas.height - 1) {
        pdf.addPage();
        y = margines;
      }
    }
  }

  const stron = pdf.getNumberOfPages();
  for (let i = 1; i <= stron; i += 1) {
    pdf.setPage(i);
    pdf.setFontSize(8);
    pdf.setTextColor(120);
    pdf.text(`Strona ${i} / ${stron}`, pageW - margines, pageH - margines / 2, {
      align: "right",
    });
  }
  pdf.save(nazwaPliku);
}
